/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseTicketAssignmentConfigList } from '../../models/api-response-ticket-assignment-config-list';

export interface GetTicketAssignmentConfig$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getTicketAssignmentConfig(http: HttpClient, rootUrl: string, params: GetTicketAssignmentConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketAssignmentConfigList>> {
  const rb = new RequestBuilder(rootUrl, getTicketAssignmentConfig.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseTicketAssignmentConfigList>;
    })
  );
}

getTicketAssignmentConfig.PATH = '/v1/api/ui/ticket-assignment-config/list';
